(function() {
  'use strict';

  var SECTION_SELECTOR = '.js-insta-slider';
  var MAX_ITEMS = 18;
  var SWIPER_CSS_URL = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
  var SWIPER_JS_URL = 'https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
  var swiperAssetsPromise = null;

  function ensureSwiperAssets() {
    if (typeof window.Swiper === 'function') {
      return Promise.resolve();
    }

    if (swiperAssetsPromise) {
      return swiperAssetsPromise;
    }

    swiperAssetsPromise = new Promise(function(resolve) {
      var head = document.head || document.getElementsByTagName('head')[0];

      if (!document.getElementById('bazar-swiper-css')) {
        var link = document.createElement('link');
        link.id = 'bazar-swiper-css';
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS_URL;
        head.appendChild(link);
      }

      var existingScript = document.getElementById('bazar-swiper-js');
      if (existingScript) {
        if (existingScript.dataset.loaded === 'true' || typeof window.Swiper === 'function') {
          resolve();
        } else {
          existingScript.addEventListener('load', function handleLoad() {
            existingScript.removeEventListener('load', handleLoad);
            resolve();
          });
          existingScript.addEventListener('error', function handleError() {
            existingScript.removeEventListener('error', handleError);
            console.error('[InstaSlider] Failed to load Swiper script.');
            resolve();
          });
        }
        return;
      }

      var script = document.createElement('script');
      script.id = 'bazar-swiper-js';
      script.src = SWIPER_JS_URL;
      script.async = true;
      script.addEventListener(
        'load',
        function() {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true }
      );
      script.addEventListener(
        'error',
        function() {
          console.error('[InstaSlider] Failed to load Swiper script.');
          resolve();
        },
        { once: true }
      );

      head.appendChild(script);
    });

    return swiperAssetsPromise;
  }

  function destroySwiper(section) {
    if (section && section._bazarSwiper && typeof section._bazarSwiper.destroy === 'function') {
      section._bazarSwiper.destroy(true, true);
    }
    if (section) {
      section._bazarSwiper = null;
      section.dataset.swiperInitialized = '';
    }
  }

  function initSwiper(section) {
    if (!section || section.dataset.swiperInitialized === 'true') {
      return;
    }

    var sliderEl = section.querySelector('.insta__swiper');
    var wrapper = section.querySelector('.swiper-wrapper');
    if (!sliderEl || !wrapper || !wrapper.children.length) {
      return;
    }

    ensureSwiperAssets().then(function() {
      if (typeof window.Swiper !== 'function') {
        console.warn('[InstaSlider] Swiper constructor missing.');
        return;
      }

      destroySwiper(section);

      section._bazarSwiper = new window.Swiper(sliderEl, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        watchOverflow: true,
        grabCursor: true,
        breakpoints: {
          750: {
            slidesPerView: 3.5,
            spaceBetween: 20
          },
          990: {
            slidesPerView: 5,
            spaceBetween: 24
          }
        }
      });

      section.dataset.swiperInitialized = 'true';
    });
  }

  function createSlideElement(post, index) {
    var article = document.createElement('article');
    article.className = 'insta__slide swiper-slide';
    article.setAttribute('role', 'listitem');

    var img = document.createElement('img');
    img.className = 'insta__image';
    img.src = post.src;
    if (post.srcset) img.srcset = post.srcset;
    if (post.sizes) img.sizes = post.sizes;
    img.alt = post.alt || '';
    img.loading = 'lazy';
    img.decoding = 'async';

    var picture = document.createElement('picture');
    picture.className = 'insta__picture';
    picture.appendChild(img);

    if (post.href) {
      var link = document.createElement('a');
      link.className = 'insta__link';
      link.href = post.href;
      link.target = '_blank';
      link.rel = 'noopener nofollow';
      link.setAttribute('aria-label', post.alt || 'Open Instagram post ' + (index + 1));
      link.appendChild(picture);
      link.appendChild(createOverlay());
      article.appendChild(link);
    } else {
      article.appendChild(picture);
      article.appendChild(createOverlay());
    }

    return article;
  }

  function renderPosts(section, posts) {
    if (!section) return;

    var wrapper = section.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var filtered = (posts || [])
      .filter(function(item) {
        return item && item.src;
      })
      .slice(0, MAX_ITEMS);

    if (!filtered.length) {
      return;
    }

    wrapper.innerHTML = '';
    var fragment = document.createDocumentFragment();

    filtered.forEach(function(post, index) {
      fragment.appendChild(createSlideElement(post, index));
    });

    wrapper.appendChild(fragment);
    initSwiper(section);
  }

  function resolveFeedSrc(img) {
    if (!img) return null;
    return (
      img.getAttribute('data-instafeed-src') ||
      img.getAttribute('data-src-large') ||
      img.getAttribute('data-src-medium') ||
      img.currentSrc ||
      img.src ||
      null
    );
  }

  function extractFeedPosts(feedRoot) {
    var posts = [];
    var seen = new Set();

    feedRoot.querySelectorAll('.instafeed-new-layout-item a[href]').forEach(function(link) {
      var href = link.href;
      if (!href || seen.has(href)) {
        return;
      }

      var img = link.querySelector('img');
      var src = resolveFeedSrc(img);
      if (!src) {
        return;
      }

      seen.add(href);
      posts.push({
        href: href,
        src: src,
        alt: (img && img.getAttribute('alt')) || ''
      });
    });

    return posts;
  }

  function hideFeed(feed) {
    if (!feed) return;
    feed.classList.add('insta-feed--hidden');
    feed.hidden = true;
    feed.setAttribute('aria-hidden', 'true');
    feed.style.display = 'none';
  }

  function renderFromFeed(section, feed) {
    if (!feed) return false;
    var posts = extractFeedPosts(feed);
    if (!posts.length) {
      return false;
    }

    hideFeed(feed);
    renderPosts(section, posts);
    return true;
  }

  function watchFeed(section, feed) {
    if (!feed) return;

    if (renderFromFeed(section, feed)) {
      return;
    }

    var observer = new MutationObserver(function() {
      if (renderFromFeed(section, feed)) {
        observer.disconnect();
      }
    });

    observer.observe(feed, { childList: true, subtree: true });
  }

  function connectToInstafeed(section) {
    if (section.dataset.instafeedBound === 'true') {
      return;
    }

    section.dataset.instafeedBound = 'true';

    var currentFeed = document.getElementById('insta-feed');
    if (currentFeed) {
      watchFeed(section, currentFeed);
      return;
    }

    var bodyObserver = new MutationObserver(function() {
      var feed = document.getElementById('insta-feed');
      if (feed) {
        watchFeed(section, feed);
        bodyObserver.disconnect();
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function mountSection(section) {
    if (!section || section.dataset.instaMounted === 'true') {
      return;
    }

    section.dataset.instaMounted = 'true';

    var sourceType = section.dataset.sourceType;

    if (sourceType === 'instafeed') {
      connectToInstafeed(section);
    } else if (sourceType === 'blocks') {
      initSwiper(section);
    }
  }

  function unmountSection(section) {
    if (!section) return;
    destroySwiper(section);
    section.dataset.instaMounted = '';
  }

  function initExistingSections() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function(section) {
      mountSection(section);
    });
  }

  function createOverlay() {
    var overlay = document.createElement('div');
    overlay.className = 'insta__overlay';

    overlay.innerHTML = '<span class="insta__overlay-icon" aria-hidden="true"></span>';
    return overlay;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExistingSections);
  } else {
    initExistingSections();
  }

  if (!window.bazarInstaSliderIcon) {
    window.bazarInstaSliderIcon = 'https://instafeed.nfcube.com/assets/img/instagram-icon-v2.svg';
  }

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target && event.target.querySelector(SECTION_SELECTOR);
    if (section) {
      mountSection(section);
    }
  });

  document.addEventListener('shopify:section:unload', function(event) {
    var section = event.target && event.target.querySelector(SECTION_SELECTOR);
    if (section) {
      unmountSection(section);
    }
  });
})();
